export default __webpack_public_path__ + "static/media/laith.30c3dd64.jpg";